<div class="row col-12 p-0 m-0 main-page-section ">
  <!-- <div class="p-0">
            <app-side-nav [item]="meetingNav"></app-side-nav>
        </div> -->
  <div class="col-12 p-0 employee-section">
    <!-- <app-header></app-header> -->
    <div class="col-height">

      <div>

        <div class="breadcrumbs-section pl-2 ml-5">
          <span class="prev-page pr-2 prev" routerLink="/overview">Home</span>
          <img src="../../assets/images/seperator.png">
          <span class="prev-page pr-2 pl-2 prev" routerLink="/vms/individual-invite">Invite</span>
          <img src="../../assets/images/seperator.png">
          <span class="curr-page pl-2 breadcrumbs-section-font current">History</span>
        </div>

        <div class="history-layout">

          <div class="row">
            <div class="col-12">
              <h1>History</h1>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p>You can access history for the last 90 days. Data beyond 90 days will be available in the reports tab.
              </p>
            </div>
          </div>

        </div>


        <div class="col-12 d-flex justify-content-between row borders m-0 p-0 ">
          <div class="col-3  borders-right d-flex justify-content-between relative-content ml-0 pl-0">

            <div class="pt-3 pb-3" (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'"
              [ngbPopover]="popMeetingRooms" triggers="manual" #p1="ngbPopover" (click)="openPopover(p1)"
              placement="bottom" popoverClass='dash-popover dashboard-popover'
              class=" meeting-label center-align box-size pointer-link text-center meeting-room-head">
              <div class="text">Company Name</div>
              <img src="../../assets/images/Path.png" class="pr-3 access-point-arrow" loading="lazy" />
              <div class="font"> {{multiSelectionCompanyName.length>1?selectedCompanyName+" +"+
                selctionlength :selectedCompanyName}}</div>

              <div>
                <ng-template #popMeetingRooms>
                  <div class="dashboard-popover ">
                    <div class="">
                      <div class="">
                        <div class="row pb-3 d-flex justify-content-between pointer-link"
                          *ngFor="let item of companyList;let i=index" (click)="selectCompanyName(item);"
                          [class]="multiSelectionCompanyName.includes(item?.buildingId) ?'bold-font':'normal-font'">
                          {{item.tenantName}}
                          <div>
                            <img src="/assets/images/tick.png"
                              *ngIf="multiSelectionCompanyName.includes(item?.buildingId) || (item?.buildingId == null && multiSelectionCompanyName.length == 0)"
                              class="pl-5 " loading="lazy" />
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                </ng-template>
              </div>
            </div>

          </div>


          <div class=" pt-3 pb-3 borders-right col-2 ">

            <div class="pl-3">
              <span class="meeting-label pt-3" style="
                            position: absolute;
                            padding-left: 31px;margin-top: -14px;">From</span>

              <input class="cal-icon all-hosts pt-3  pointer-link" (click)="d1.toggle()" [(ngModel)]="fDate"
                ngbDatepicker #d1="ngbDatepicker" (dateSelect)="updateSelectedDate($event)">

              <div class="meeting-sub-label from-date">{{formattedSelectedDate}}</div>

            </div>

          </div>
          <div class="pl-3 pt-3 pb-3 col-2 borders-right  ">
            <span class="meeting-label pt-3" style="
                            position: absolute;
                            padding-left: 31px;margin-top: -14px;">To</span>

            <input class="cal-icon all-hosts pt-3  pointer-link" (click)="d2.toggle()" [(ngModel)]="tDate" ngbDatepicker
              #d2="ngbDatepicker" (dateSelect)="updateSelectedToDate($event)">
            <div class="meeting-sub-label from-date">{{formattedSelectedToDate}}</div>

          </div>
          <div [ngClass]="'col-4'">
            <label for="search">
              <img loading="lazy" class=" search-layout" src="/assets/images/search.png" alt="search">
              <input class="search-box search-padding placeholder-text " type="text" name="search" id="menu-search"
                [(ngModel)]="searchText" placeholder="Type here to search…">
            </label>
          </div>

        </div>

        <label class="padding-report pt-2 pb-2 column-data " style="margin-top: 10px;" *ngIf="historyList.length>0">
          {{historyList?.length}} results found for you
        </label>

        <div class="history-layout mt-4 pb-5 mb-5">

          <div class="row meeting-row mt-2 ml-0 " *ngFor="let item of historyList| filter:searchText|paginate: { itemsPerPage: 10,
            currentPage: page,
            totalItems:100 } ">
            <div class="col-1 date">
              <p>{{formatDate(item?.mstart,'date')}}</p>
              <p class="month">{{formatDate(item?.mstart,'month')}}</p>
            </div>
            <div (click)="navigateToDetail(item?.invitationID)" class="col-8 pl-4 pt-1">
              <div style="display: flex;">
                <p class="name" *ngFor="let name of item?.t0600Vmsguests|slice:item?.t0600Vmsguests?.length-2">
                  {{name?.fullName}}<span>,</span></p><span *ngIf="item?.t0600Vmsguests?.length>2">+
                  {{item?.t0600Vmsguests?.length-2}} more</span>
              </div>
              <p class="detail">Booked on {{formatDate(item?.mstart,'format')}}</p>
            </div>
            <div class="col-1"></div>
            <div class="col-2 align-right">
              <button (click)="navigate('individual')">Rejected</button>
            </div>
          </div>




        </div>


         <div class="d-flex justify-content-center pagination-section" >
            <div class="row d-flex pagination-border">
              <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChange($event)"
              nextLabel="" class="d-flex justify-content-center">
            </pagination-controls>
              <div class="pr-3 ratio-class pt-1" *ngIf="tempHistoryList?.length>=10">{{historyList.length}}/{{tempHistoryList?.length}}</div>
            </div>
          </div>

        <!-- <app-footer></app-footer> -->

      </div>
    </div>
